import { render, staticRenderFns } from "./BriefcaseTable.vue?vue&type=template&id=ae88463e&scoped=true&"
import script from "./BriefcaseTable.vue?vue&type=script&lang=js&"
export * from "./BriefcaseTable.vue?vue&type=script&lang=js&"
import style0 from "./BriefcaseTable.vue?vue&type=style&index=0&id=ae88463e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae88463e",
  null
  
)

export default component.exports